import { render, staticRenderFns } from "./ProVersion.vue?vue&type=template&id=0f43b03b&scoped=true&"
import script from "./ProVersion.vue?vue&type=script&lang=js&"
export * from "./ProVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f43b03b",
  null
  
)

export default component.exports